import { jsxs, jsx } from "react/jsx-runtime";
import { List } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const BlockListItem = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    content,
    ...restAttrs
  } = attrs;
  return /* @__PURE__ */ jsxs(List.Item, { ...restAttrs, children: [
    /* @__PURE__ */ jsx("div", { children: makeContentInteractive(content) }),
    generateBlockList({
      blocks: innerBlocks
    })
  ] }, index);
};
BlockListItem.propTypes = {
  attrs: PropTypes.shape({
    content: PropTypes.string
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockListItem as default
};
